/**
 * The project map in full screen (`?fs=1`) needs the project's details (its sites and alignments: stationing, station
 * ranges). The project page fetches them; a bookmarked full-screen URL opened cold never renders that page, so the map
 * would have none. Fetch only then: full screen, and the store holds no details for this project. With them already
 * there (the map opened from the page), never again, since a fetch empties the store until it answers.
 */
export function mapNeedsProjectDetails(details: { id?: string } | null | undefined, projectId: string | null | undefined, fullScreen: boolean): boolean {
  return fullScreen && !!projectId && !(details && Object.keys(details).length && details.id === projectId);
}

/** The minimum the map uses: the project row (with alignment_geometry) and its sites' geometry */
export function mapProjectDetailsPayload(projectId: string) {
  return { projectId, qp: { include: [{ sites: ['geometry'] }] } };
}
